import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import "./sidebar.css";
import { hostInfo } from '../server';


function Home({ onNewBlog, blogs, setBlogs }) {
  const [ipo, setIpo] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [error, setError] = useState(null);
  const location = useLocation();
  const { database } = location.state || {};
  const navigate = useNavigate();
  const { blogId } = useParams();
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [showNotSuccessNotification, setShowNotSuccessNotification] =
    useState(false);
  const [markdown, setMarkdown] = useState({
    IssuerCompanyID: "",
    title: "",
    image_url: "",
    summary: "",
    tags: "",
    description: "",
    extra_info: "",
    date: new Date(),
    postdate: "",
    published_by: "",
    flag: "",
    title_route_name: "",
    external_blog_link: "",
    check_allotment:"",
    redirect_to_external: "",                       
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (blogId) {
      fetch(hostInfo + `/blog/${blogId}`)
        .then((response) => response.json())
        .then((data) => {
          setMarkdown(data[0]);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [blogId]);

    useEffect(() => {
    const fetchIpoData = async () => {
      try {
        const response = await fetch(hostInfo + `/api/ipo`);
        
        // Check if the response is OK (status 200-299)
        if (!response.ok) {
          throw new Error('Error fetching IPO data.');
        }

        const data = await response.json(); // Convert the response to JSON
        setIpo(data);
      } catch (err) {
        setError('Error fetching IPO data.');
        console.error('Error fetching IPO data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchIpoData();
  }, []);

  const handleSubmit = (e) => {
  e.preventDefault();

  const url = blogId ? `${hostInfo}/blog/${blogId}` : `${hostInfo}/blog/`;

  fetch(url, {
    method: blogId ? "PUT" : "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(markdown),
  })
    .then((response) => response.json())
    .then((data) => {
      // Check if the operation was successful based on the server response
      if (data.status === 1) {
        // If successful, reset the form and show success notification
        onNewBlog(data);

        setMarkdown({
          IssuerCompanyID: "",
          title: "",
          image_url: "",
          summary: "",
          tags: "",
          description: "",
          extra_info: "",
          date: "",
          postdate: "",
          published_by: "",
          flag: "",
          title_route_name: "",
          external_blog_link: "",
          check_allotment:"",
          redirect_to_external: 0,
        });

        setShowSuccessNotification(true);

        // Show a success message in an alert box
        //alert(data.message);

        setTimeout(() => {
          setShowSuccessNotification(false);
          window.location.reload(); // Reload the page after a short delay
        }, 1000);
      } else {
        // If not successful, show the error message in an alert box
        alert(data.message);
      }
    })
    .catch((error) => {
      console.error("Error saving blog:", error);

      // If there is an error during the fetch, show an error notification
      setShowNotSuccessNotification(true);

      setTimeout(() => setShowNotSuccessNotification(false), 3000);
    });
};



const handleChange = (event) => {
  const { name, value } = event.target;
  setMarkdown((prevValues) => ({
    ...prevValues,
    [name]: value,
  }));
  setSelectedCompanyId(value);
};

  const handleRedirectChange = (event) => {
    const value = event.target.value === "yes" ? 1 : 0;
    setMarkdown((prevValues) => ({
      ...prevValues,
      redirect_to_external: value,
    }));
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ display: "flex" }}>
      <Sidebar database={database} blogs={blogs} />
      <main className="main-content" style={{ flex: 1, padding: "20px" }}>
        <h2 style={{ textAlign: "center", marginTop: "-5px" }}>Blog Details</h2>
        <form onSubmit={handleSubmit}>
        <div className="form-container">
  <div className="form-group">
  <label className="label">Issuer Company ID:</label>
<select
  name="issuer_company_id"
  value={markdown.issuer_company_id || "" } 
  onChange={(e) => setMarkdown({ ...markdown, issuer_company_id: e.target.value })}
  className="input"
>
  <option value="" disabled>Select a company ID</option>
  {ipo.map((ipoItem) => (
    <option key={ipoItem.ID} value={ipoItem.ID}>
      {`${ipoItem.ID} - ${ipoItem.IssuerCompany}`}
    </option>
  ))}
</select>
  </div>
  <div className="form-group">
    <label className="label">Title:</label>
    <input
      name="title"
      value={markdown.title}
      onChange={handleChange}
      className="input"
    />
  </div>
  <div className="form-group full-width">
  <label className="label">Description:</label>
  <div className="description-container">
    <textarea
      name="description"
      value={markdown.description}
      onChange={handleChange}
      className="textarea"
    />
    <div className="preview-container">
      <ReactMarkdown>{markdown.description}</ReactMarkdown>
    </div>
  </div>
</div>

  <div className="form-group">
    <label className="label">Image Url:</label>
    <input
      name="image_url"
      value={markdown.image_url}
      onChange={handleChange}
      className="input"
    />
  </div>
  <div className="form-group">
    <label className="label">Tags:</label>
    <input
      name="tags"
      value={markdown.tags}
      onChange={handleChange}
      className="input"
    />
  </div>

  <div className="form-group full-width">
    <label className="label">Summary:</label>
    <textarea
      name="summary"
      value={markdown.summary}
      onChange={handleChange}
      className="textarea"
    />
  </div>
  <div className="form-group">
    <label className="label">Extra Info:</label>
    <input
      name="extra_info"
      value={markdown.extra_info}
      onChange={handleChange}
      className="input"
    />
  </div>
  <div className="form-group">
    <label className="label">Post date:</label>
    <input
      type="date"
      name="postdate"
      value={markdown.post_date ? markdown.post_date.split('T')[0] : ""}
      onChange={handleChange}
      className="input"
    />
  </div>
  <div className="form-group">
    <label className="label">Published By:</label>
    <input
      name="published_by"
      value={markdown.publishedby}
      onChange={handleChange}
      className="input"
    />
  </div>
  <div className="form-group">
    <label className="label">Flag:</label>
    <input
      name="flag"
      value={markdown.flag}
      onChange={handleChange}
      className="input"
    />
  </div>
  <div className="form-group">
    <label className="label">Title Route Name:</label>
    <input
      name="title_route_name"
      value={markdown.title_route_name}
      onChange={handleChange}
      className="input"
    />
  </div>
  <div className="form-group">
    <label className="label">External Blog Link:</label>
    <input
      name="external_blog_link"
      value={markdown.external_blog_link}
      onChange={handleChange}
      className="input"
    />
  </div>
  <div className="form-group">
    <label className="label">Check Allotment:</label>
    <input
      name="check_allotment"
      value={markdown.check_allotment}
      onChange={handleChange}
      className="input"
    />
  </div>
  <div className="form-group">
    <label className="label">Redirect to External:</label>
    <div className="radio-group">
      <label>
        <input
          type="radio"
          name="redirect"
          value="yes"
          checked={markdown.redirect_to_external === 1}
          onChange={handleRedirectChange}
        />
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="redirect"
          value="no"
          checked={markdown.redirect_to_external === 0}
          onChange={handleRedirectChange}
        />
        No
      </label>
    </div>
  </div>
</div>
          <button type="submit" style={submitButtonStyle}>
            Save Blog
          </button>

          {showSuccessNotification && (
            <div className="notification success">Blog saved successfully!</div>
          )}
          {showNotSuccessNotification && (
            <div style={notificationStyle}>Failed to save blog.</div>
          )}
        </form>
      </main>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "8px",
  marginBottom: "10px",
  borderRadius: "4px",
  border: "1px solid #ccc",
};

const textareaStyle = {
  width: "100%",
  height: "150px",
  padding: "8px",
  borderRadius: "4px",
  border: "1px solid #ccc",
};

const gridContainerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "20px",
};

const submitButtonStyle = {
  marginTop: "20px",
  padding: "10px 20px",
  backgroundColor: "#4CAF50",
  color: "white",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
};

const redirectButtonStyle = {
  margin: "5px",
  padding: "10px 20px",
  backgroundColor: "#4CAF50",
  color: "white",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
};

const notificationStyle = {
  color: "green",
  marginTop: "10px",
};

export default Home;